<template>
    <div>

        <el-dialog :title="'上线审批：' + tempRow.workerName" :visible.sync="showruzhi" width="1100px"
            :close-on-click-modal="false" center>
            <el-row>
                <el-tag effect="dark"> 培训记录 </el-tag>
                <el-table :data="gendanPeixun.enrolmentList" border style="width: 100%" class="table">
                    <el-table-column prop="courseArrangement.id" label="课程安排编号" width="100"></el-table-column>
                    <el-table-column prop="courseArrangement.courseName" label="课程名称" width="120"></el-table-column>
                    <el-table-column prop="courseArrangement.lectureUserName" label="讲师" width="100"></el-table-column>
                    <el-table-column prop="startTime" label="上课时间" width="150">
                        <template slot-scope="scope">
                            {{ formateTime(scope.row.courseArrangement.startTime) }}<br /> 至<br />
                            {{ formateTime(scope.row.courseArrangement.endTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="isPass" label="状态" width="100">
                        <template slot-scope="scope">
                            {{ pxisPassType[scope.row.isPass] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="score" label="得分" width="80"></el-table-column>
                    <el-table-column prop="comment" label="评价" width="150"></el-table-column>
                    <el-table-column prop="raterName" label="评分人" width="100"></el-table-column>

                    <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                </el-table>
                <br />
            </el-row>
            <el-row>
                <el-tag effect="dark"> 跟单记录</el-tag>
                <el-table :data="gendanPeixun.gendanList" border style="width: 100%" class="table">
                    <el-table-column label="跟单批次id" prop="ojtId"></el-table-column>
                    <el-table-column label="跟单师傅" prop="masterWorkerName"></el-table-column>
                    <el-table-column label="跟单时间" prop="ojtrTime"></el-table-column>
                    <el-table-column label="关联盒马工单" prop="hmTradeNo"></el-table-column>
                    <el-table-column label="跟单评语" prop="ojtrComment"></el-table-column> 
                    <el-table-column label="跟单状态" prop="ojtState" width="100">
                        <template slot-scope="scope">
                            <span>{{ gdstatusList.find(a => a.value == scope.row.ojtState).name }}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <el-tag effect="dark"> 跟单结果</el-tag>
                <el-table :data="gendanPeixun.gendanResult" border style="width: 100%" class="table">
                    <el-table-column label="跟单id" prop="id"></el-table-column>
                    <el-table-column label="跟单类型" prop="onJobType">
                        <template slot-scope="scope">
                            <span>{{ gdtypeList.find(a => a.typeId == scope.row.onJobType).name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="跟单结果" prop="ojtResult" width="100">
                        <template slot-scope="scope">
                            <span>{{ scope.row.ojtResult === "" ? "" : scope.row.ojtResult == true ? "通过" : "不通过"
                            }}</span>
                        </template>
                    </el-table-column> 
                    <el-table-column label="跟单数量" prop="onJobNum" width="90"></el-table-column>
                </el-table>
                <br />
            </el-row>

            <el-row>
                <el-tag effect="dark">特招批准（若无跟单培训记录需选择是否特招，且上传凭证） </el-tag>
                <br /><br />
                <el-form>
                    <el-col :span="8">
                        <el-form-item label="是否特招" prop="specialRecu">
                            <el-select v-model="specialRecu" placeholder="全部" style="width:220px">
                                <el-option label="是" :value="true">是</el-option>
                                <el-option label="否" :value="false">否</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-upload :action="addFile" :on-change="handleOnChange" :file-list="addLabelImgList" :limit="2"
                            :on-exceed="uploadOverrun" :auto-upload="false" :on-remove="handleRemove"
                            accept=".jpg, .jpeg, .png, .gif" list-type="picture-card">
                            <i class="el-icon-plus" />
                        </el-upload>
                    </el-col>
                </el-form>
            </el-row>

            <el-row>
                <br />
                <center>
                    <el-button @click="showruzhi = false">取消</el-button>
                    <el-button type="danger" @click="approval(3)">驳回</el-button>
                    <el-button type="primary" @click="approval(2)">通过</el-button>
                </center>
            </el-row>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    data() {
        return {
            tempRow: {},
            gdtypeList: [
                { name: "赋能跟单", typeId: "1" },
                { name: "治理跟单", typeId: "2" },
            ],
            gdstatusList: [
                { name: "待安排", value: "0" },
                { name: "跟单中", value: "1" },
                { name: "跟单完成", value: "2" },
                { name: "取消", value: "3" },
            ],
            pxisPassType: {
                0: "未评分",
                1: "通过",
                2: "未通过",
                3: "已取消",
            },
            showruzhi: false,
            gendanPeixun: {
                enrolmentList: [],
                gendanList: [],
                gendanResult: []
            },
            specialRecu: false,
            specialRecuUrl: '',
            addFile: service.addFile + globalData.userInfo.userAccount,
            addLabelImgList: [],
        };
    },
    beforeCreate() {
        vm = this;
    },
    methods: {
        handleRemove: function (file, fileList) {
            console.log(file, fileList);
            this.addLabelImgList = fileList;
        },
        uploadOverrun: function () {
            this.$message({
                type: "error",
                message: "上传文件个数超出限制!最多上传2张图片!"
            });
        },
        handleOnChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (file.raw) {
                console.log("上传文件大小" + file.raw.size);

                let filesize = Number(file.size / 1024 / 1024);
                if (filesize > 3) {
                    this.$message.error("上传图片不能超过3M,请重新上传");
                    const currIdx = this.addLabelImgList.indexOf(file)
                    this.addLabelImgList.splice(currIdx, 0)
                    return;
                }

                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file.raw);
                service.$ajaxAddFile(param).then(res => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        console.log(res);
                        file.url = res.data.data.fileUrl;
                        this.addLabelImgList = fileList;
                        console.log(this.addLabelImgList);
                        //  this.skillImgList.push(res.data.data.fileUrl);
                    }
                });
            }
        },
        toSp(row) {
            this.showruzhi = true;
            this.tempRow = row;
            workercrmapi
                .$axiosgetOnjobTraiEnrolment({ workerNo: row.workerNo })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.gendanPeixun = res.data.data;
                    }
                });
        },
        approval(approveState) {
            let req = {
                id: this.tempRow.id,
                approveState: approveState,
                operId: globalData.userInfo.id,
                operName: globalData.userInfo.userName,
                specialRecu: this.specialRecu,
            };
            if (approveState == 2 && this.specialRecu == true && this.addLabelImgList.length == 0) {
                this.$message.error('特招审批通过需要上传凭证');
                return;
            }
            if (this.addLabelImgList.length > 0) {
                let labelImg = this.addLabelImgList.map(item => {
                    return item.url;
                });
                req.specialRecuUrl = labelImg.join(',');
            }
            workercrmapi.$axiosEmploymentApproval(req).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showruzhi = false;
                    this.$parent.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
    },
};
</script>
<style></style>
